import { getUser } from './user';
import get from 'growth-payments-core/object/get';
import { useCallback } from 'react';
import { useUserInfo } from '../hooks/useUserInfo';
import memoizeOne from 'react-utils/memoizeOne';

/**
 * Simple enum to keep track of the scopes we care about
 */
export let Scopes;
(function (Scopes) {
  Scopes["paymentsEligible"] = "payments-eligible";
  Scopes["paymentLinksRead"] = "payment-links-read";
  Scopes["paymentLinksWrite"] = "payment-links-write";
  Scopes["paymentLinksDelete"] = "payment-links-delete";
  Scopes["superAdmin"] = "super-admin";
  Scopes["commerceSpecialistsGrowthContactAccess"] = "commerce-specialists-growth-contact-access";
  Scopes["cpqQuoteAccess"] = "cpq-quote-access";
  Scopes["cpqQuoteCreate"] = "cpq-quote-create";
  Scopes["cqtQuoteCreate"] = "quote-create";
  Scopes["cqtQuoteAccess"] = "quote-access";
  Scopes["crmEditAllDeals"] = "crm-edit-all-deals";
  Scopes["crmEditTeamOwnedDeals"] = "crm-edit-team-owned-deals";
  Scopes["crmEditUnassignedDeals"] = "crm-edit-unassigned-deals";
  Scopes["crmEditOwnedDeals"] = "crm-edit-owned-deals";
})(Scopes || (Scopes = {}));
const EMPTY_SCOPES = new Set();

// gates don't change over the lifetime of the app. use a memoized helper to
// ensure that all calls to the `useGetIsUngated` hook share one Set,
// instead of each hook call/component building its own
const memoizedToScopesSet = memoizeOne(scopes => new Set(scopes));
export const useScopes = () => {
  const userInfo = useUserInfo();
  const userInfoScopes = !(userInfo !== null && userInfo !== void 0 && userInfo.user) ? EMPTY_SCOPES : memoizedToScopesSet(userInfo.user.scopes);
  return userInfoScopes;
};
export const getScopes = () => {
  const user = getUser();
  const scopesSet = get(user, 'scopes');
  return scopesSet;
};
export function hasScope(scope, scopes) {
  if (Array.isArray(scopes)) {
    return scopes.includes(scope);
  }
  return scopes.has(scope);
}
export const useHasAllScopes = () => {
  const scopesSet = useScopes();
  return useCallback((...scopes) => scopes.every(scope => scopesSet.has(scope)), [scopesSet]);
};